import gql from "graphql-tag"

export const CREATE_OR_UPDATE_CUSTOM_PAYMENT_CONFIG = gql`
  mutation createOrUpdateCustomPaymentConfig(
    $id: ID!
    $customPaymentConfig: InputCustomPaymentConfig!
  ) {
    createOrUpdateCustomPaymentConfig(
      id: $id
      customPaymentConfig: $customPaymentConfig
    ) {
      id
    }
  }
`
